import { cn } from '@workingclock/ui';

/**
 * A short gold rule set above hero headings. WorkingClock runs on a single
 * accent (chronometer gold, DESIGN.md §2), so the boldness here is a small,
 * high-contrast mark — a "second-hand tick" — rather than more color. Flat,
 * no shadow, purely decorative (aria-hidden).
 */
export function AccentBar({ className }: { className?: string }) {
  return <div className={cn('h-1.5 w-12 rounded-full bg-gold', className)} aria-hidden />;
}
